import React from "react";
import withAnimation from "../../../utils/withAnimation";

const CustomerInfoWrapper = (props) => <div>{props.children}</div>;

export default withAnimation(CustomerInfoWrapper);
